
export class CostDetail
{

    public monthlyStatus: string
    public workingStatus: string
    public ifCommuteRoute: boolean
    public ym: string
    public empCd: string
    public targetDate: string
    public detailNo: number
    public costAmount: number
    public dailyAllowanceAmount: number
    public costKbn: string
    public detailStatus: string
    public receiptInfo: string
    public lowestPrice: number
    public lowestInfo:string
    public commuteRouteKbn: string
    public startTime: string
    public orderKbn: string
    public passKey: string
    public passInfo: string
    public startStation: string
    public endStation: string
    public transitStation: string
    public startStationCd: string
    public endStationCd: string
    public transitStationCd: string
    public roundKbn: string
    public requestDate: Date
    public requestEmpCd: string
    public userRemarks: string
    public lastRegistrationDate: string
    public lastRegistrationEmpCd: string
    public lastRegistrationEmpNm: string
    public decisionRemarks: string
    public decisionDate: string
    public decisionEmpCd: string
    public decisionEmpNm: string
    public approvalDate1st: string
    public approvalEmpCd1st: string
    public approvalEmpNm1st: string
    public approvalDate2nd: string
    public approvalEmpCd2nd: string
    public approvalEmpNm2nd: string
    public approvalDate3rd: string
    public approvalEmpCd3rd: string
    public approvalEmpNm3rd: string
    public confirmDate1st: string
    public confirmEmpCd1st: string
    public confirmEmpNm1st: string
    public confirmDate2nd: string
    public confirmEmpCd2nd: string
    public confirmEmpNm2nd: string
    public confirmDate3rd: string
    public confirmEmpCd3rd: string
    public confirmEmpNm3rd: string
    public renewDate: string
    public renewUser: string
}

